// ---------------------------------------------- modules import
import { PostAction, PostActionType } from "./common";

// ---------------------------------------------- action creators
class Actions {
  static addBegin = (): PostAction => ({
    type: PostActionType.ADD_POST_BEGIN
  });

  static addSuccess = (): PostAction => ({
    type: PostActionType.ADD_POST_SUCCESS
  });

  static addError = (error: string): PostAction => ({
    type: PostActionType.ADD_POST_ERROR,
    payload: {
      error
    }
  });

  static pinBegin = (): PostAction => ({
    type: PostActionType.PIN_POST_BEGIN
  });

  static pinSuccess = (): PostAction => ({
    type: PostActionType.PIN_POST_SUCCESS
  });

  static pinError = (error: string): PostAction => ({
    type: PostActionType.PIN_POST_ERROR,
    payload: {
      error
    }
  });

  static updateBegin = (): PostAction => ({
    type: PostActionType.UPDATE_POST_BEGIN
  });

  static updateSuccess = (): PostAction => ({
    type: PostActionType.UPDATE_POST_SUCCESS
  });

  static updateError = (error: string): PostAction => ({
    type: PostActionType.UPDATE_POST_ERROR,
    payload: {
      error
    }
  });

  static deleteBegin = (): PostAction => ({
    type: PostActionType.DELETE_POST_BEGIN
  });

  static deleteSuccess = (): PostAction => ({
    type: PostActionType.DELETE_POST_SUCCESS
  });

  static deleteError = (error: string): PostAction => ({
    type: PostActionType.DELETE_POST_ERROR,
    payload: {
      error
    }
  });
}

export default Actions;
